import {
  HttpClient,
  HttpHeaders,
  HttpResponse,
  HttpResponseBase,
} from '@angular/common/http';
import { Inject, Injectable, Optional } from '@angular/core';
import {
  API_BASE_URL,
  SwaggerException,
  UploadImageResponse,
} from '../api-connector/sso-connector';
import { AlertService } from './alert.service';
import {
  mergeMap as _observableMergeMap,
  catchError as _observableCatch,
  map,
} from 'rxjs/operators';
import {
  Observable,
  throwError as _observableThrow,
  of as _observableOf,
} from 'rxjs';
/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.7.0.0 (NJsonSchema v10.1.24.0 (Newtonsoft.Json v11.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming
@Injectable({
  providedIn: 'root',
})
export class UploadService {
  private http: HttpClient;
  private baseUrl: string;
  private jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;
  constructor(
    http: HttpClient,
    private alertService: AlertService,
    @Optional() @Inject(API_BASE_URL) baseUrl?: string
  ) {
    this.http = http;
    this.baseUrl = baseUrl ? baseUrl : '';
  }
  uploadFile(file: any, type: any, sizeType: any): Observable<UploadImageResponse> {
    return this.uploadFileAPI(file, type, sizeType).pipe(
      map((x) => UploadImageResponse.fromJS(x))
    );
  }

  uploadMultipeFile(
    files: any[],
    type: any,
    sizeImage: any
  ): Observable<UploadImageResponse[]> {
    return this.uploadMultipeFileAPI(files, type, sizeImage).pipe(
      map(
        (x: any) =>
          // x.forEach(function (value) {
          //   UploadImageResponse.fromJS(value);
          // })
          x
      )
    );
  }

  private uploadMultipeFileAPI(files: any[], type: any, sizeImage: any): Observable<any[]> {
    let url$ = this.baseUrl + '/api/File/UploadFiles';
    url$ = url$.replace(/[?&]$/, '');
    // const options$: any = ;
    const formData: FormData = new FormData();
    for (var i = 0; i < files.length; i++) {
      formData.append('files[' + i + ']', files[i]);
    }
    formData.append('Type', type);
    formData.append('SizeType', sizeImage);
    return this.http
      .request('post', url$, {
        observe: 'response',
        responseType: 'blob',
        body: formData,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      })
      .pipe(
        _observableMergeMap((response$: any) => {
          return this.processResponse(response$);
        })
      )
      .pipe(
        _observableCatch((response$: any) => {
          if (response$ instanceof HttpResponseBase) {
            try {
              return this.processResponse(<any>response$);
            } catch (e) {
              return <Observable<any | null>>(<any>_observableThrow(e));
            }
          } else
            return <Observable<any | null>>(<any>_observableThrow(response$));
        })
      );
  }

  getUrlFile(id: string) {
    return this.baseUrl + `/api/File/GetFile/${id}`;
  }

  getUrlFiles(ids: string): any {
    let lstFiles: any[] = [];
    let lstImg = JSON.parse(ids);
    if (lstImg && lstImg.length > 0) {
      lstImg.forEach((element: any) => {
        lstFiles.push(this.baseUrl + `/api/File/GetFile/${element}`);
      });
    }
    return lstFiles;
  }

  private uploadFileAPI(file: any, type: any, sizeType: any): Observable<any> {
    let url$ = this.baseUrl + '/api/File/Upload?';
    url$ = url$.replace(/[?&]$/, '');
    // const options$: any = ;
    const formData: FormData = new FormData();
    formData.append('file', file);
    formData.append('Type', type);
    formData.append('SizeType', sizeType);
    return this.http
      .request('post', url$, {
        observe: 'response',
        responseType: 'blob',
        body: formData,
        headers: new HttpHeaders({
          Accept: 'application/json',
        }),
      })
      .pipe(
        _observableMergeMap((response$: any) => {
          return this.processResponse(response$);
        })
      )
      .pipe(
        _observableCatch((response$: any) => {
          if (response$ instanceof HttpResponseBase) {
            try {
              return this.processResponse(<any>response$);
            } catch (e) {
              return <Observable<any | null>>(<any>_observableThrow(e));
            }
          } else
            return <Observable<any | null>>(<any>_observableThrow(response$));
        })
      );
  }
  private processResponse(response: HttpResponseBase): Observable<any> {
    const status = response.status;
    const responseBlob =
      response instanceof HttpResponse
        ? response.body
        : (<any>response).error instanceof Blob
          ? (<any>response).error
          : undefined;

    let _headers: any = {};
    if (response.headers) {
      for (let key of response.headers.keys()) {
        _headers[key] = response.headers.get(key);
      }
    }
    if (status === 200) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          let result200: any = null;
          let resultData200 =
            _responseText === ''
              ? null
              : JSON.parse(_responseText, this.jsonParseReviver);
          result200 = resultData200 ? resultData200 : <any>null;
          return _observableOf(result200);
        })
      );
    } else if (status !== 200 && status !== 204) {
      return blobToText(responseBlob).pipe(
        _observableMergeMap((_responseText) => {
          return throwException(
            'An unexpected server error occurred.',
            status,
            _responseText,
            _headers
          );
        })
      );
    }
    return _observableOf<any | null>(<any>null);
  }
}
function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): Observable<any> {
  if (result !== null && result !== undefined) return _observableThrow(result);
  else
    return _observableThrow(
      new SwaggerException(message, status, response, headers, null)
    );
}

function blobToText(blob: any): Observable<string> {
  return new Observable<string>((observer: any) => {
    if (!blob) {
      observer.next('');
      observer.complete();
    } else {
      let reader = new FileReader();
      reader.onload = (event) => {
        observer.next((<any>event.target).result);
        observer.complete();
      };
      reader.readAsText(blob);
    }
  });
}
